// DS: i4.21
import React from 'react';
import IconWrap from '../../IconWrap';
const Quill = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.087 10.755c-.259.426-.528.875-.802 1.336-.767 1.104-1.463 2.175-1.823 2.902C7.384 17.169 4 23 4 23l2.902-1.716s.058-.238 1.373-2.786c4.979-2.323 7.04-4.9 7.648-6.352.158-.257.24-.484.224-.66-.91.464-2.924 1.365-3.698 1.257 2.058-.944 6.252-3.52 6.566-6.274-.831.458-2.311 1.25-3.289.995 2.016-.54 5.29-2.538 3.968-6.465l-.025.007c-2.365-.061-6.013.759-8.734 3.539l.002.005c-.394.901-.903 2.89.22 3.642-.507-.15-1.41-.81-1.346-2.303-1.566 2.198-2.603 5.294-2.5 9.586l4.998-6.621-1.222 1.9Z",
        fill: "currentColor"
    })));
};
Quill.displayName = 'Quill';
export default Quill;

//# sourceMappingURL=Quill.js.map